module.exports = __webpack_public_path__ + "img/silver-vip.71c6b64d.svg";